import { render, staticRenderFns } from "./DeleteTestimonialModal.vue?vue&type=template&id=8aac79b8&"
import script from "./DeleteTestimonialModal.vue?vue&type=script&lang=js&"
export * from "./DeleteTestimonialModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports